// extracted by mini-css-extract-plugin
module.exports = {"input":"link__input___yB8f7","inputInvalid":"link__inputInvalid___2-eSI","link":"link__link___1OWg5"};